import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useShipmentData } from './DataProviders';


function CityStatePostalCode({ city, state, postalCode }: { city:string, state:string, postalCode:string }) {
  return <FormattedMessage
    description="cityStatePostalCode"
    defaultMessage="{cityOrLocality}, {stateOrProvince} {postalCode}"
    values={{ cityOrLocality: city, stateOrProvince: state, postalCode }}
  />;
}

export function AbbreviatedDestinationAddress({ className='' }) {
  const { destination } = useShipmentData();
  return <div className={`city-state-zip ${className}`} data-testid="destination-city-state-zip">
    <CityStatePostalCode city={destination.city} state={destination.state} postalCode={destination.postal_code} />
  </div>;
}
